module.exports = __webpack_public_path__ + "img/img-113.78aa809b.png";